// hooks/useGeocoding.js
import { useCallback } from 'react';
import { GOOGLE_MAPS_API_KEY } from '../config/googleMapsConfig';

const useGeocoding = () => {
  const geocodeAddress = useCallback(async (address) => {
    const cached = localStorage.getItem(`geocode_${address}`);
    if (cached) return JSON.parse(cached);

    try {
      const response = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
          address
        )}&key=${GOOGLE_MAPS_API_KEY}`
      );
      const data = await response.json();
      if (data.results && data.results[0]) {
        const result = {
          coordinates: data.results[0].geometry.location,
          formattedAddress: data.results[0].formatted_address,
          components: data.results[0].address_components,
        };
        localStorage.setItem(`geocode_${address}`, JSON.stringify(result));
        return result;
      }
      return null;
    } catch (error) {
      console.error('Geocoding error:', error);
      return null;
    }
  }, []);

  const reverseGeocode = useCallback(async (lat, lng) => {
    const cached = localStorage.getItem(`reverse_geocode_${lat}_${lng}`);
    if (cached) return JSON.parse(cached);

    try {
      const response = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${GOOGLE_MAPS_API_KEY}`
      );
      const data = await response.json();
      if (data.results && data.results[0]) {
        const result = {
          formattedAddress: data.results[0].formatted_address,
          components: data.results[0].address_components,
        };
        localStorage.setItem(`reverse_geocode_${lat}_${lng}`, JSON.stringify(result));
        return result;
      }
      return null;
    } catch (error) {
      console.error('Reverse geocoding error:', error);
      return null;
    }
  }, []);

  return { geocodeAddress, reverseGeocode };
};

export { useGeocoding };
